import api from "./client";

export const scenarioGenerationsAPI = {
  start: (payload) => api.post("/api/v1/scenario_generations", payload).then(r => r.data),
  get:   (id, clientId) =>
    api.get(`/api/v1/scenario_generations/${id}`, { params: { client_id: clientId } }).then(r => r.data),
};
